import React from 'react';
import { Box, Button, Heading, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'i18n/TranslationProvider';

export default function ForbiddenPage({ title = '403', subtitle = 'Access denied', message, homePath = '/' }) {
  const { t } = useTranslation();
  const cardBg = useColorModeValue('white', 'navy.800');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');
  const textMuted = useColorModeValue('gray.600', 'gray.300');

  return (
    <Box
      minH="calc(100vh - 180px)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={{ base: 4, md: 6 }}
    >
      <Box
        w="100%"
        bg={cardBg}
        border="1px solid"
        borderColor={borderColor}
        borderRadius="20px"
        p={{ base: 6, md: 8 }}
        boxShadow="0 20px 45px rgba(10, 26, 63, 0.12)"
      >
        <Stack spacing={4} align="start">
          <Heading size="2xl">{title}</Heading>
          <Heading size="md">{t(subtitle)}</Heading>
          <Text color={textMuted}>
            {message ? t(message) : t('Your role does not have permission to open this page.')}
          </Text>
          <Button as={RouterLink} to={homePath} colorScheme="blue">
            {t('Go to dashboard')}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}
